/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Proposal_Content__InstructionsInputs */

const en_home_proposal_content__instructions = /** @type {(inputs: Home_Proposal_Content__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'Stop' isn't addressed at the reader.`)
};

/**
* | output |
* | --- |
* | "'Stop' isn't addressed at the reader." |
*
* @param {Home_Proposal_Content__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_proposal_content__instructions = /** @type {((inputs?: Home_Proposal_Content__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Proposal_Content__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_proposal_content__instructions(inputs)
});